// Labels every team profile shares, English: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Personal Details',
    rows: {
      name: 'Name',
      position: 'Position',
      birthdate: 'Date of Birth',
      nationality: 'Nationality',
      maritalStatus: 'Marital Status',
      location: 'Location',
      languages: 'Languages',
      programmingLanguages: 'Programming Languages',
      certifications: 'Certifications',
      publications: 'Publications',
      links: 'Website'
    }
  },
  education: {
    title: 'Education'
  },
  skills: {
    title: 'Specialised Skills'
  },
  experience: {
    title: 'Projects and Activities',
    techLabel: 'Technologies'
  },
  downloads: {
    title: 'Download profile',
    deLabel: 'Download German profile',
    deDescription: 'PDF in German',
    enLabel: 'Download English CV',
    enDescription: 'PDF in English'
  },
  cta: {
    title: 'Contact',
    button: 'Get in touch'
  },
  pdf: {
    title: 'Profile',
    pageNumber: 'Page {page} of {pages}',
    phoneLabel: 'Phone',
    managingDirectors: 'Managing directors',
    personalSection: 'Personal Details',
    educationSection: 'Education',
    experienceSection: 'Projects and Activities',
    skillsLabel: 'Skills',
    personalLabels: {
      programmingLanguages: 'Programming'
    }
  }
};
